const FORM_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Puerto Rico',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'U.S. Virgin Islands',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'Washington, D.C.',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
] as const;

const WOUND_LOCATIONS = [
  { value: 'leg', label: 'On my leg' },
  { value: 'foot', label: 'On my foot' },
  { value: 'face_head', label: 'On my face or head' },
  { value: 'other', label: 'On another part of my body' },
] as const;

const USER_TYPES = [
  { value: 'patient', label: 'I am a patient' },
  { value: 'caregiver', label: 'I am a caregiver' },
] as const;

export { FORM_STATES, WOUND_LOCATIONS, USER_TYPES };
